import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnChanges,
  SimpleChanges,
  ChangeDetectorRef,
  OnInit,
  OnDestroy,
} from '@angular/core';
import {OphSelectMenuComponent} from '../oph-select-menu/oph-select-menu.component';
import {FormControl} from '@angular/forms';
import {Subscription} from 'rxjs';

@Component({
  selector: 'oph-time-selector',
  standalone: true,
  imports: [OphSelectMenuComponent],
  templateUrl: './oph-time-selector.component.html',
  styleUrl: './oph-time-selector.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OphTimeSelectorComponent implements OnChanges, OnInit, OnDestroy {
  @Input() hoursControl: FormControl;
  @Input() minutesControl: FormControl;
  @Input() ampmControl: FormControl;

  hours = Array.from({length: 12}, (_, i) => ({
    name: (i + 1).toString(),
    value: (i + 1).toString(),
  }));

  minutes = Array.from({length: 12}, (_, i) => ({
    name: (i * 5).toString().padStart(2, '0'),
    value: (i * 5).toString(),
  }));

  ampm = [
    {name: 'AM', value: 'AM'},
    {name: 'PM', value: 'PM'},
  ];

  selectButtonStyle = {width: '70px'};

  private subscriptions: Subscription[] = [];

  constructor(private cdr: ChangeDetectorRef) {}

  ngOnInit() {
    // Subscribe to form control changes
    if (this.hoursControl) {
      this.subscriptions.push(this.hoursControl.valueChanges.subscribe(() => this.cdr.markForCheck()));
    }

    if (this.minutesControl) {
      this.subscriptions.push(this.minutesControl.valueChanges.subscribe(() => this.cdr.markForCheck()));
    }

    if (this.ampmControl) {
      this.subscriptions.push(this.ampmControl.valueChanges.subscribe(() => this.cdr.markForCheck()));
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    this.cdr.markForCheck();
  }

  ngOnDestroy() {
    // Clean up subscriptions
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }

  onTimeChange(type: 'hour' | 'minute' | 'ampm', value: string) {
    if (type === 'hour') {
      this.hoursControl.patchValue(value);
    } else if (type === 'minute') {
      this.minutesControl.patchValue(value.padStart(2, '0'));
    } else if (type === 'ampm') {
      this.ampmControl.patchValue(value);
    }
  }
}
